<div id="chart-canvas-container" class="chart-container">
  <canvas
    #chartContainerEle
    [id]="'base-chart-canvas-' + unique_id"
    class="basechart-js"
  >
  </canvas>
</div>
